import { createReducer, createActions } from 'reduxsauce';

export const MOVEOUT_STAGE = {
  DATE_RANGE: 'dateRange',
  PROPERTY: 'property'
};

const { Types, Creators } = createActions({
  setMoveoutStep: ['step'],
  setMoveoutDateRangeInfo: ['dateRangeInfo'],
  setMoveoutPropertyInfo: ['propertyInfo'],
  setInitialState: ['initialState']
});

export const MoveoutTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  step: MOVEOUT_STAGE.DATE_RANGE,
  dateRangeInfo: {},
  propertyInfo: null
};

/* ------- Selectors --------- */
export const MoveoutSelectors = {
  selectCurrentStep: state => state.moveout.step,
  selectDateRangeInfo: state => state.moveout.dateRangeInfo,
  selectPropertyInfo: state => state.moveout.propertyInfo
};

/* -------- Reducers ---------- */
export const setStep = (state, { step }) => {
  return {
    ...state,
    step
  };
};

export const setMoveoutDateRangeInfo = (state, { dateRangeInfo }) => {
  return {
    ...state,
    dateRangeInfo
  };
};

export const setMoveoutPropertyInfo = (state, { propertyInfo }) => {
  return {
    ...state,
    propertyInfo
  };
};

export const setInitialState = () => {
  return { ...INITIAL_STATE };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_MOVEOUT_DATE_RANGE_INFO]: setMoveoutDateRangeInfo,
  [Types.SET_MOVEOUT_PROPERTY_INFO]: setMoveoutPropertyInfo,
  [Types.SET_MOVEOUT_STEP]: setStep,
  [Types.SET_INITIAL_STATE]: setInitialState
});
